import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Lightweight version badge shown in the sidebar footer.
// Fetches /api/version once on mount and caches for the session.
export default function VersionBadge() {
  const [v, setV] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get("/version")
      .then((r) => { if (!cancelled) setV(r.data); })
      .catch(() => { if (!cancelled) setV({ commit: "?", status: "error" }); });
    return () => { cancelled = true; };
  }, []);

  if (!v) return null;
  const label = v.commit || "?";
  const deployed = v.deployed_at ? new Date(v.deployed_at) : null;
  const timeStr = deployed && !isNaN(deployed) ? deployed.toLocaleString("es-AR", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" }) : "";

  return (
    <div
      className="px-2 text-[10px] text-muted-foreground/70 font-mono flex items-center justify-between gap-2"
      title={timeStr ? `Desplegado ${timeStr}` : "Versión local (no VPS)"}
      data-testid="sidebar-version-badge"
    >
      <span>v.{label}</span>
      {timeStr && <span className="truncate">{timeStr}</span>}
    </div>
  );
}
